const StatCard = ({ label, value, description, icon: IconComponent, highlight }) => {
  return (
    <div className="bg-white rounded-2xl p-4 border border-slate-100/80 shadow-xs flex items-center gap-4 hover:shadow-md transition-all">
      <div className="w-10 h-10 rounded-full bg-teal-50 text-[#067978] flex items-center justify-center flex-shrink-0">
        {IconComponent && <IconComponent className="w-5 h-5 text-[#067978]" />}
      </div>
      <div>
        <p className="text-xs text-slate-500 font-medium">{label}</p>
        <h3 className={`text-2xl font-black mt-0.5 ${highlight ? 'text-[#067978]' : 'text-slate-900'}`}>
          {value}
        </h3>
        <p className="text-[11px] text-slate-400 font-normal mt-0.5">{description}</p>
      </div>
    </div>
  );
};

export default StatCard;
